import React from 'react';
import { FaBookOpen } from 'react-icons/fa';
import { get } from 'lodash';
import { getTranslationKey } from '../../modules/utils/helpers';

const onClickHelpLink = function (e: React.MouseEvent<HTMLAnchorElement>) {
  try {
    const href = get(e, 'target.href', '');
    const intercomBooted = get(window, 'Intercom.booted');
    if (href.includes('articles') && intercomBooted) {
      const articleId = href.substring(href.lastIndexOf('/') + 1);
      if (articleId && window.Intercom) {
        window.Intercom('showArticle', articleId);
        e.preventDefault();
      }
    }
  } catch (error) {
    console.log(error);
  }
};

interface HelpLinkProps {
  href: string;
  className?: string;
  target?: string;
  hideSmall?: boolean;
  video?: boolean;
}

const HelpLink: React.FC<HelpLinkProps> = ({
  href,
  className = '',
  target = '',
  hideSmall = false,
  video = false
}) => (
  <div className="float-right">
    <a
      href={href}
      target={target || '_blank'}
      className={className || 'badge badge-info'}
      onClick={onClickHelpLink}
      rel="noreferrer"
    >
      {video ? (
        <i className="fa fa-video-camera" />
      ) : (
        <FaBookOpen style={{ marginBottom: '2px' }} />
      )}
      {!hideSmall && <small className="m-l-5">{getTranslationKey('helpButton')}</small>}
    </a>
  </div>
);

export default HelpLink;
